import "regenerator-runtime/runtime";
import {AnimationImage} from './animation_image';
import {MountainScene} from './mountain_scene';
import {viewport} from './viewport';
import {qS} from './dom';
import {qSA} from './dom';
import {style} from './css';

(function($, Drupal) {
  Drupal.behaviors.scrollingAnimatedNode = {
    attach: function(context, settings) {
      $(once('animation-area', '.animation-area')).each(this.setup.bind(this));
    },

    onAfter: function(index, sections) {
      if (index != 0) {
        return;
      }
      this.mountainScene.run();
    },

    scrollFooterDown: function(event) {
      this.footer.classList.add('down');
      this.footer.classList.remove('up');
    },

    scrollFooterUp: function(event) {
      event.stopPropagation();
      this.footer.classList.add('up');
      this.footer.classList.remove('down');
    },

    setup: async function() {
      style(qSA('.scene'), {'display': 'block'});
      this.mountainScene = new MountainScene();
      this.setupFooter();
      const options = {
        after: this.onAfter.bind(this),
        section: '.scene',
        interstitialSection: '.footer-scene',
      };
      $.scrollify(options);
      const hash = document.location.hash;
      if (hash == '#home' || hash == '') {
        this.onAfter(0, null);
      }
    },

    setupFooter: function() {
      this.footer = qS('footer');
      const bunnyEars = $('.bunny-ears');
      bunnyEars.on('click', this.scrollFooterUp.bind(this));
      $('.scenes').on('click', this.scrollFooterDown.bind(this));
      $('.region-primary-menu').on('click', this.scrollFooterDown.bind(this));
      $(window).on('scroll', this.scrollFooterDown.bind(this));
    },
  }
})(jQuery, Drupal);
